module.exports = __webpack_public_path__ + "static/media/gh.806190a6.webp";